(function () {
  'use strict';

  const initCollection = () => {
    document.querySelectorAll('[data-l-collection]').forEach((root) => {
      if (root.dataset.lCollectionInit) return;
      root.dataset.lCollectionInit = '1';

      const searchInput = root.querySelector('[data-l-collection-search]');
      const cards = root.querySelectorAll('[data-l-product-card]');

      searchInput?.addEventListener('input', () => {
        const q = searchInput.value.trim().toLowerCase();
        cards.forEach((card) => {
          const title = (card.dataset.productTitle || '').toLowerCase();
          card.style.display = !q || title.includes(q) ? '' : 'none';
        });
      });

      root.querySelector('[data-l-subcats-prev]')?.addEventListener('click', () => {
        root.querySelector('[data-l-subcats-track]')?.scrollBy({ left: -240, behavior: 'smooth' });
      });
      root.querySelector('[data-l-subcats-next]')?.addEventListener('click', () => {
        root.querySelector('[data-l-subcats-track]')?.scrollBy({ left: 240, behavior: 'smooth' });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollection);
  } else {
    initCollection();
  }
  document.addEventListener('shopify:section:load', initCollection);
})();
